// extracted by mini-css-extract-plugin
export var dropdownButton = "_1o-0";
export var fullWidthDropdownButton = "_1o-1";
export var icon = "_1o-3";
export var iconPlaceholder = "_1o-2";
export var menuItemRow = "_1o-9";
export var separator = "_1o-e";
export var shortcutContainer = "_1o-7";
export var shortcutContainerFilled = "_1o-8";
export var shortcutIconLg = "_1o-6";
export var shortcutIconMd = "_1o-5";
export var shortcutIconSm = "_1o-4";
export var submenuChevron = "_1o-d";
export var submenuDropdown = "_1o-a";
export var submenuTriggerRow = "_1o-b";
export var submenuTriggerRowOpen = "_1o-c";